var parseFormat = require('./lib/parseformat')
module.exports = parseFormat

/* istanbul ignore next */
if (typeof window !== 'undefined' && window.moment) {
  window.moment.parseFormat = parseFormat
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/moment-parseformat/index.js
 ** module id = 274
 ** module chunks = 0
 **/